import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '@/styles/User/ProfilePage.less';
import { Navigate } from 'react-router-dom';
import Loader from '@/components/UI/Loader';
import { useAuth } from '@/context/AuthContext';
const ProfilePage = () => {
    const { user, loading, logout } = useAuth();
    if (loading)
        return _jsx(Loader, {});
    if (!user)
        return _jsx(Navigate, { to: "/auth" });
    return (_jsxs("div", { className: "profile-page", children: [_jsx("h1", { children: "Profile Page" }), _jsxs("div", { className: "user-container", children: [_jsxs("div", { className: "username", children: [_jsx("span", { children: "username:" }), _jsx("span", { children: user.username })] }), _jsxs("div", { className: "email", children: [_jsx("span", { children: "Email:" }), _jsx("span", { children: user.email })] }), _jsx("div", { className: "buttons", children: _jsx("button", { onClick: logout, children: "Logout" }) })] }), _jsxs("div", { className: "subscription-container", children: [_jsx("div", { className: "current-subscription" }), _jsx("div", { className: "subscription-plan" })] })] }));
};
export default ProfilePage;
